import {useCallback} from "react"
import {useDropzone} from "react-dropzone"
import {Icon} from "components"
import cx from "classnames"
import styles from "./AudioFileSelect.module.css"

const ACCEPTED_AUDIO = ".mp3,.wav,audio/mpeg,audio/mp3,audio/wav,audio/wave,audio/x-wav"

type Props = {
    onSelectFile: (file: File) => void
    disabled?: boolean
    className?: string
}

export function AudioFileSelect(props: Props) {
    const {onSelectFile, disabled, className} = props

    const onDrop = useCallback(
        (acceptedFiles: File[]) => {
            if (disabled || !acceptedFiles.length) return
            onSelectFile(acceptedFiles[0])
        },
        [disabled, onSelectFile]
    )

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: ACCEPTED_AUDIO,
        multiple: false,
        disabled
    })

    return (
        <div
            className={cx(styles.dropzone, className, {
                [styles.dropzoneActive]: isDragActive,
                [styles.dropzoneDisabled]: disabled
            })}
            {...getRootProps()}>
            <input {...getInputProps()} />
            <div className={styles.iconWrap}>
                <Icon icon="UPLOAD" />
            </div>
            <div className={styles.desc}>
                <span className={styles.uploadLabel}>Click to upload</span>
                <span className={styles.uploadDescLabel}>Or drag and drop an MP3 or WAV file</span>
            </div>
        </div>
    )
}
